import { categoryIcon } from "@gerama/ui";
import { cn } from "@gerama/utils";
import { MediaImage as Image } from "@/components/media-image";

export { categoryGradient, categoryIcon } from "@gerama/ui";

/**
 * The tilted art in a category tile's corner: its picture when the admin set
 * one, otherwise a frosted card with an icon for the genre — so a category
 * without a picture still looks finished instead of an empty colour block.
 */
export function CategoryArt({
  category,
  className,
  sizes = "112px",
}: {
  category: { id: number; name: string; image: string | null };
  /** Size and position of the tilted square (absolute, in the tile's corner). */
  className: string;
  sizes?: string;
}) {
  const Icon = categoryIcon(category);
  return (
    <span
      aria-hidden
      className={cn(
        "absolute rotate-[25deg] overflow-hidden rounded-lg shadow-xl shadow-black/40 transition-transform duration-300 group-hover:scale-105 group-hover:rotate-[20deg]",
        !category.image &&
          "flex items-center justify-center bg-white/15 ring-1 ring-white/25 backdrop-blur-sm",
        className,
      )}
    >
      {category.image ? (
        <Image src={category.image} alt="" fill sizes={sizes} className="object-cover" />
      ) : (
        <Icon className="size-1/2 -rotate-[25deg] text-white/90" strokeWidth={1.75} />
      )}
    </span>
  );
}
